import { css } from '@emotion/react';
import { lighten } from '@mui/material';
import { theme } from 'global';

export const root = css`
  & .MuiAutocomplete-clearIndicator {
    margin-right: 8px;
  }
`;

export const paper = css`
  border: solid 1px ${lighten(theme.colors.neutral[300], 0.8)};
  border-radius: 4px;
  box-shadow: 0px 0px 4px 1px ${lighten(theme.colors.black, 0.85)};
`;
